import BaseDTO from '../base/BaseDTO';
import ContentDTO from './ContentDTO';

export default class Media extends BaseDTO {
    public filename: string | undefined;
    public description: string | undefined;
    public content: ContentDTO | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.filename = data['filename'] || undefined;
        this.description = data['description'] || undefined;
        this.content = data['content'] ? new ContentDTO(data['content']) : undefined;
    }
}
